export default __webpack_public_path__ + "static/media/complete.01d363e9.svg";